// extracted by mini-css-extract-plugin
export default {"line-reader-icon-down":"line-reader-icon-down-zDMpR"};